import { Application } from '@hotwired/stimulus'

import AccountNavController from './controllers/account_nav_controller'
import AnchorsController from './controllers/anchors_controller'
import AssistantChatController from './controllers/assistant_chat_controller'
import BenefitsSliderController from './controllers/benefits_slider_controller'
import CatalogController from './controllers/catalog_controller'
import CatalogFiltersController from './controllers/catalog_filters_controller'
import CatalogMapController from './controllers/catalog_map_controller'
import ClubAvailabilityController from './controllers/club_availability_controller'
import ClubFacilitiesController from './controllers/club_facilities_controller'
import ClubPhotosController from './controllers/club_photos_controller'
import CheckboxController from './controllers/checkbox_controller'
import CoachMapController from './controllers/coach_map_controller'
import ClubLocationMapController from './controllers/club_location_map_controller'
import CodeExampleController from './controllers/code_example_controller'
import CopyController from './controllers/copy_controller'
import ConfirmFormController from './controllers/confirm_form_controller'
import ContentGalleryController from './controllers/content_gallery_controller'
import DropdownController from './controllers/dropdown_controller'
import DirectoryFilterController from './controllers/directory_filter_controller'
import FAQController from './controllers/faq_controller'
import FooterAnimationController from './controllers/footer_animation_controller'
import FormValidationController from './controllers/form_validation_controller'
import GalleryController from './controllers/gallery_controller'
import HeaderController from './controllers/header_controller'
import InputController from './controllers/input_controller'
import LikeButtonController from './controllers/like_button_controller'
import LoginModalController from './controllers/login_modal_controller'
import LocalesController from './controllers/locales_controller'
import ModalController from './controllers/modal_controller'
import MultipageFormController from './controllers/multipage_form_controller'
import PageAnchorsController from './controllers/page_anchors_controller'
import QuizController from './controllers/quiz_controller'
import RatingController from './controllers/rating_controller'
import ResponsiveDetailsController from './controllers/responsive_details_controller'
import SearchFormController from './controllers/search_form_controller'
import ReviewFormController from './controllers/review_form_controller'
import ScrollDirectionController from './controllers/scroll_direction_controller'
import SelectController from './controllers/select_controller'
import SortController from './controllers/sort_controller'
import StickySearchController from './controllers/sticky_search_controller'
import SwiperController from './controllers/swiper_controller'
import TextPathScrollController from './controllers/text_path_scroll_controller'
import TournamentClubController from './controllers/tournament_club_controller'
import TournamentFormController from './controllers/tournament_form_controller'
import TournamentPaidController from './controllers/tournament_paid_controller'
import TournamentScoreController from './controllers/tournament_score_controller'
import TournamentShareController from './controllers/tournament_share_controller'
import ThemesController from './controllers/themes_controller'
import ToasterController from './controllers/toaster_controller'
import TranslationController from './controllers/translation_controller'
import TurboSubmitSpinnerController from './controllers/turbo_submit_spinner_controller'
import TypoController from './controllers/typo_controller'
import UploadFileController from './controllers/upload_file_controller'
import WidgetKitController from './controllers/widget_kit_controller'

const application = Application.start()
application.register('account-nav', AccountNavController)
application.register('anchors', AnchorsController)
application.register('assistant-chat', AssistantChatController)
application.register('benefits-slider', BenefitsSliderController)
application.register('catalog', CatalogController)
application.register('catalog-filters', CatalogFiltersController)
application.register('catalog-map', CatalogMapController)
application.register('club-availability', ClubAvailabilityController)
application.register('club-facilities', ClubFacilitiesController)
application.register('club-photos', ClubPhotosController)
application.register('checkbox', CheckboxController)
application.register('coach-map', CoachMapController)
application.register('club-location-map', ClubLocationMapController)
application.register('code-example', CodeExampleController)
application.register('confirm-form', ConfirmFormController)
application.register('content-gallery', ContentGalleryController)
application.register('copy', CopyController)
application.register('dropdown', DropdownController)
application.register('directory-filter', DirectoryFilterController)
application.register('faq', FAQController)
application.register('footer-animation', FooterAnimationController)
application.register('form-validation', FormValidationController)
application.register('gallery', GalleryController)
application.register('header', HeaderController)
application.register('input', InputController)
application.register('like-button', LikeButtonController)
application.register('login-modal', LoginModalController)
application.register('locales', LocalesController)
application.register('modal', ModalController)
application.register('multipage-form', MultipageFormController)
application.register('page-anchors', PageAnchorsController)
application.register('quiz', QuizController)
application.register('rating', RatingController)
application.register('responsive-details', ResponsiveDetailsController)
application.register('search-form', SearchFormController)
application.register('review-form', ReviewFormController)
application.register('scroll-direction', ScrollDirectionController)
application.register('select', SelectController)
application.register('sort', SortController)
application.register('sticky-search', StickySearchController)
application.register('swiper', SwiperController)
application.register('text-path-scroll', TextPathScrollController)
application.register('themes', ThemesController)
application.register('toaster', ToasterController)
application.register('tournament-club', TournamentClubController)
application.register('tournament-form', TournamentFormController)
application.register('tournament-paid', TournamentPaidController)
application.register('tournament-score', TournamentScoreController)
application.register('tournament-share', TournamentShareController)
application.register('translation', TranslationController)
application.register('turbo-submit-spinner', TurboSubmitSpinnerController)
application.register('typo', TypoController)
application.register('upload-file', UploadFileController)
application.register('widget-kit', WidgetKitController)
